import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalApprovePost from "root/Modals/ApprovePost/ModalApprovePost";

const useModalApprovePost = (onSaveCompleted ) =>
{
    const [dialog, setDialog]  = useState ( { openState: false, mode: 'none', child_uid: null, post_id: null, messageType: null   })  ;

    const onClickActivate = ( mode, child_uid, post_id, messageType ) =>
    {
        setDialog ({ openState: true, mode: mode, child_uid: child_uid, post_id: post_id, messageType: messageType });
    }

    const onCloseModal = () =>
    {
        setDialog ({ openState: false, mode: 'none', post_id: null, messageType: null});
    };

    const onSaveComplete = ( result ) =>
    {
        setDialog ({ openState: false, mode: 'none', child_uid: null, post_id: null, messageType: null });

        // Tell the parent we're done
        onSaveCompleted( result ) ;
    };

    const render = ( props ) =>
    {
        return (
            <Modal center focusTrapped={false} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                < ModalApprovePost post_id={dialog.post_id} mode={dialog.mode} messageType={dialog.messageType} onSaveCompleted={onSaveComplete} onClose={onCloseModal} title="Approve Post"  />
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalApprovePost ;
